var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCallUs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M8.484 19.547A22 22 0 0 1 6.33 17.67C2.86 14.2.955 10.009.938 6.539c-.01-1.948.575-3.668 1.811-4.905l.027-.024a2.63 2.63 0 0 1 3.65.132c1.97 2.042 3.154 4.084 1.172 6.114l-1.74 1.753s1.01 2.268 3.575 4.834l.124.124c2.566 2.565 4.834 3.575 4.834 3.575l1.753-1.74c2.03-1.982 4.072-.797 6.114 1.172a2.63 2.63 0 0 1 .132 3.65l-.024.027c-1.237 1.236-2.957 1.821-4.904 1.811-1.562-.008-3.27-.428-4.993-1.171m8.437-18.797-6.14 6.14m.562-8.296L13.5 4.734m9.563 3.938L19.266 10.5"
})));
export default SvgCallUs;